import React from 'react';
import {
	ContentDesctiption,
	ContentWrapper,
	ContentContainer,
	ContentTitle,
	ContentBox,
	ContentItem,
	Icon,
	Payouts,
	Payout
} from './ContentStyled';
import useCoefData from '../helpers/useCoefData';
import { GameConfigs } from '../../lib/globals/GameConfigs';
export default function SymbolPayout({
	dimentions,
	coefs,
	currentBet,
	slice,
	currency,
	text,
	name
}) {
	const [data] = useCoefData(coefs);
	return (
		<ContentWrapper scale={dimentions.scale}>
			<ContentContainer name={name}>
				{text.map((item, id) => (
					<div key={id} style={{ margin: 'auto' }}>
						<ContentTitle
							scale={dimentions.scale}
							style={id === 1 ? { color: '#CEEE71' } : {}}
						>
							{item.title}
						</ContentTitle>
						<ContentDesctiption scale={dimentions.scale}>
							{item.desc}
						</ContentDesctiption>
					</div>
				))}
			</ContentContainer>
			<ContentBox name={name}>
				{data &&
					data.slice(slice.a, slice.b).map((item, id) => (
						<ContentItem key={id} name={name}>
							<Icon scale={dimentions.scale}>
								<img src={item.icon} alt='symbol' />
							</Icon>
							<Payouts scale={dimentions.scale} name={name}>
								{/* TODO reverse this payouts */}
								{item.coef.map(
									(c, id) =>
										c !== 0 && (
											<Payout key={id}>
												<span>{id + 1}</span>
												<p>
													{(currency.length > 1 ? currency + ' ' : currency) +
														((c * currentBet) / 10).toLocaleString(undefined, {
															minimumFractionDigits:
																GameConfigs.config.currency_prec,
															maximumFractionDigits:
																GameConfigs.config.currency_prec
														})}
												</p>
											</Payout>
										)
								)}
							</Payouts>
						</ContentItem>
					))}
			</ContentBox>
		</ContentWrapper>
	);
}
